import { defineStore } from "pinia";

export type LegalItem = {
  attributes: {
    slug: string;
    title: string;
  };
};
export type LegalState = {
  data: {
    data?: LegalItem[];
  } | null;
  pending: boolean;
  error: any;
};
export const useLegalStore = defineStore("legal", {
  state: () =>
    ({
      data: null,
      pending: true,
      error: null,
    } as LegalState),

  getters: {
    legalItems(state) {
      return state.data?.data;
    },
  },
  actions: {
    async fetchLegal() {
      this.data = null;
      this.pending = true;
      try {
        const reqParams = {
          sort: "position",
          fields: ["title", "slug", "updatedAt", "content", "tosType"],
          "populate[content][populate]": "*",
        };
        this.data = await $fetch("/api/legals", { params: reqParams });
      } catch (error) {
        this.error = error;
      } finally {
        this.pending = false;
      }
    },
    getLegalItem(slug: any) {
      return this.legalItems?.find((item: any) => item.attributes.slug === slug)
        ?.attributes;
    },
  },
});
